var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rightsUrl !== '')?_c('div',{staticClass:"agree"},[_vm._v("开通即同意"),_c('a',{attrs:{"href":_vm.rightsUrl}},[_vm._v("《会员须知》")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"btn",class:{bigBtn:_vm.bigBtn,disable: _vm.disable},on:{"click":_vm.btnClick}},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-759b3046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NormalBtn.vue
// module id = null
// module chunks = 